const zh = {
  form: {
    transactionTime: '交易时间',
    websiteName: '网站',
    all: '全部',
    group: '群组',
    logisticsCompany: '物流公司',
    uploadStatus: '上传状态',
    transactionId: '网站订单号',
    trackingNumber: '物流单号',
    logisticsCompanyURL: '物流查询网站',
    uploaded: '已上传',
    not_uploaded: '未上传',
    noLimited: '不限',
    logisticsNumber: '物流单号',
    goodsName: '商品名称',
    logisticsCompanyName: '物流公司名称'
  },
  warning: {
    start: '您当前还有',
    end: '条订单没有上传订单信息，为了避免影响结算，请尽快上传'
  },
  button: {
    search: '筛选',
    reset: '重置筛选条件',
    upload: '批量上传信息',
    download: '下载批量模板',
    export: '导出当前结果',
    modify: '修改',
    uploadByOne: '上传',
    cancel: '取消',
    confirm: '确定'

  },
  table: {
    orderidAndWebsiteName: '网站订单号/网站',
    transactionTime: '交易时间',
    uploadStatus: '上传状态',
    goodsName: '商品名称',
    orderidAndCompany: '物流单号/物流公司',
    logisticsCompanyURL: '物流查询网址',
    uploadTime: '更新时间',
    operation: '操作',
    modify: '修改',
    uploadByOne: '上传',
    uploaded: '已上传',
    notUploaded: '未上传'
  },
  alert: {
    uploadTip: '请先点击 ‘导出当前结果’，再补充物流信息并上传',
    coverTip: '文件中存在订单号已有物流信息，是否确定覆盖？',
    excTip: '文件中以下商户订单号对应字段信息异常，其余订单信息已上传',
    notExit: '文件中以下商户订单号不存在或无需上传物流信息，其余订单信息已上传',
    moreTip: '文件中存在大量信息异常请核实后重新上传',
    moreNotExit: '文件中大量商户订单号不存在或无需上传物流信息，请核实后重新上传。',
    upload: '上传物流信息',
    modify: '修改物流信息',
    uploading: '数据上传中，请稍等，请不要刷新网页'
  }
}

export default zh
